/*
 * Copyright (c) 2021. American Express Company
 */

export default class ObjectUtils {
    /**
     * traverses a deep object, replacing matches
     * @param o - the object
     * @param k - the key to match
     * @param v - the value to match
     * @param rv - the replacement value
     */
    public static deepReplace(o: any, k: string, v: any, rv: any): Object {
        Object.keys(o).forEach((key: string) => {
            if (key === k && o[key] === v) {
                o[key] = rv;
                return;
            }
            if (o[key] instanceof Object) {
                this.deepReplace(o[key], k, v, rv);
            }
        });

        return o;
    }

    /**
     * does the string array include the string value, using case-insensitive comparison
     * @param collection - the array of strings
     * @param value - the value to check for
     */
    public static caseInsensitiveIncludes(array: string[], value: string): boolean {
        return array?.map((x) => x.toLowerCase()).includes(value.toLowerCase());
    }

    public static parseStringToInt(intString: string): number {
        try {
            return +intString;
        } catch (_) {
            return null;
        }
    }
}
